window.BeeArmorOpenCartDrawer = async function BeeArmorOpenCartDrawer() {
  try {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await response.json();
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        data: {
          itemCount: cart.item_count || 0,
          source: 'bee-armor-fallback'
        }
      }
    }));
  } catch (error) {
    console.error('Bee Armor cart drawer refresh failed', error);
  }

  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
};

document.addEventListener('submit', async function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;

  const submitter = event.submitter;
  if (submitter && submitter.hasAttribute('formnovalidate')) return;

  event.preventDefault();

 const submitterBtn = event.submitter;
  if (submitterBtn) {
    submitterBtn.disabled = true;
    submitterBtn.textContent = 'Adding...';
    submitterBtn.style.opacity = '0.75';
  }

  try {
    const formData = new FormData(form);

    const cartBefore = await fetch('/cart.js', { credentials: 'same-origin' });
    const cartBeforeData = await cartBefore.json();
    const existingKeys = cartBeforeData.items.map(i => i.key);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Add to cart failed');

    if (existingKeys.length > 0) {
      const cartAfter = await fetch('/cart.js', { credentials: 'same-origin' });
      const cartAfterData = await cartAfter.json();
      const newItem = cartAfterData.items.find(i => !existingKeys.includes(i.key));
      if (newItem) {
        const updates = {};
        cartAfterData.items.forEach(item => {
          updates[item.key] = item.quantity;
        });
        const orderedKeys = [...existingKeys, newItem.key];
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
          credentials: 'same-origin'
        });
      }
    }
    if (submitterBtn) {
      submitterBtn.textContent = 'Added ✓';
      submitterBtn.style.opacity = '1';
      submitterBtn.style.background = '#c8a820';
    }
    await window.BeeArmorOpenCartDrawer();
  } catch (error) {
    console.error(error);
    if (submitterBtn) {
      submitterBtn.disabled = false;
      submitterBtn.textContent = 'Add';
      submitterBtn.style.opacity = '1';
    }
    window.location.href = '/cart';
  }
}, true);
